// extracted by mini-css-extract-plugin
export var container = "_bh-0";
export var icon = "_bh-1";
export var text = "_bh-2";